module.exports = __webpack_public_path__ + "static/media/Acheive9.2fa53c9b.jpeg";